<template>
<div>
{{ checkModal }}


  <b-modal v-model="modalShow" ref="my-modal" hide-footer title="Создание ленты">

    <div class="row">
      <div class="col-12 mb-3">
    <input type="text" class="form-control mb-3" id="add-name" v-model="lentaName" name="name" placeholder="Введите название ленты*">
<div v-if="platform.type == 'photo'" class="form-check form-switch mb-3">  
        <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" v-model="laccess">
        <label class="form-check-label" for="flexSwitchCheckChecked">Общедоступная лента</label>
</div>

    <div class="col-12 mb-3" v-if="kinder_groups.length > 0">
    <select name="kinder_group" id="kinder_group" placeholder="Выберите группу" tabindex="-1" class="selectized" style="display: none;">
  <option value="0" selected="selected">Без группы</option></select>
  <v-selectize v-model="kinder_group" :options="kinder_groups" key-by="id" label="name"/>
      </div>

    <select name="cat" id="select-cats" placeholder="Выберите тематику" tabindex="-1" class="selectized" style="display: none;">
  <option value="0" selected="selected">Без категории</option></select>
  <v-selectize v-if="platform.type != 'photo'" v-model="selected" :options="options" key-by="id" label="title"/>
      </div>
          <div class="col-4" v-if="platform.type != 'photo'">
            <div :class="[ socSelect == 'vk' ? 'lenta-create_type active' : 'lenta-create_type' ]" @click.prevent="swapSoc('vk')">
              <svg class="icon-bg-vk" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 48 48" fill="none">
<path d="M25.54 34.5801C14.6 34.5801 8.3601 27.0801 8.1001 14.6001H13.5801C13.7601 23.7601 17.8 27.6401 21 28.4401V14.6001H26.1602V22.5001C29.3202 22.1601 32.6398 18.5601 33.7598 14.6001H38.9199C38.0599 19.4801 34.4599 23.0801 31.8999 24.5601C34.4599 25.7601 38.5601 28.9001 40.1201 34.5801H34.4399C33.2199 30.7801 30.1802 27.8401 26.1602 27.4401V34.5801H25.54Z" fill="white"></path>
</svg>
              <span>Вконтакте</span>
            </div>
          </div>
          <div class="col-4" v-if="platform.type != 'photo'">
            <div :class="[ socSelect == 'tg' ? 'lenta-create_type active' : 'lenta-create_type' ]" @click.prevent="swapSoc('tg')">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon-bg-tg" width="24" height="24" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Livello_1" x="0px" y="0px" viewBox="0 0 240.1 240.1" enable-background="new 0 0 240.1 240.1" xml:space="preserve">
<g id="Artboard">
	<path id="Path-3" fill-rule="evenodd" clip-rule="evenodd" fill="white" d="M54.3,118.8c35-15.2,58.3-25.3,70-30.2   c33.3-13.9,40.3-16.3,44.8-16.4c1,0,3.2,0.2,4.7,1.4c1.2,1,1.5,2.3,1.7,3.3s0.4,3.1,0.2,4.7c-1.8,19-9.6,65.1-13.6,86.3   c-1.7,9-5,12-8.2,12.3c-7,0.6-12.3-4.6-19-9c-10.6-6.9-16.5-11.2-26.8-18c-11.9-7.8-4.2-12.1,2.6-19.1c1.8-1.8,32.5-29.8,33.1-32.3   c0.1-0.3,0.1-1.5-0.6-2.1c-0.7-0.6-1.7-0.4-2.5-0.2c-1.1,0.2-17.9,11.4-50.6,33.5c-4.8,3.3-9.1,4.9-13,4.8   c-4.3-0.1-12.5-2.4-18.7-4.4c-7.5-2.4-13.5-3.7-13-7.9C45.7,123.3,48.7,121.1,54.3,118.8z"></path>
</g>
</svg>
              <span>Телеграм</span>
            </div>
          </div>
          <div class="col-4" v-if="platform.type != 'photo'">
            <div :class="[ socSelect == 'post' ? 'lenta-create_type active' : 'lenta-create_type' ]" @click.prevent="swapSoc('post')">
              <svg class="icon-bg-post p-16" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.6602 10.44L20.6802 14.62C19.8402 18.23 18.1802 19.69 15.0602 19.39C14.5602 19.35 14.0202 19.26 13.4402 19.12L11.7602 18.72C7.59018 17.73 6.30018 15.67 7.28018 11.49L8.26018 7.30001C8.46018 6.45001 8.70018 5.71001 9.00018 5.10001C10.1702 2.68001 12.1602 2.03001 15.5002 2.82001L17.1702 3.21001C21.3602 4.19001 22.6402 6.26001 21.6602 10.44Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M15.0599 19.39C14.4399 19.81 13.6599 20.16 12.7099 20.47L11.1299 20.99C7.15985 22.27 5.06985 21.2 3.77985 17.23L2.49985 13.28C1.21985 9.30998 2.27985 7.20998 6.24985 5.92998L7.82985 5.40998C8.23985 5.27998 8.62985 5.16998 8.99985 5.09998C8.69985 5.70998 8.45985 6.44998 8.25985 7.29998L7.27985 11.49C6.29985 15.67 7.58985 17.73 11.7599 18.72L13.4399 19.12C14.0199 19.26 14.5599 19.35 15.0599 19.39Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>
              <span>Конструктор</span>
            </div>
          </div>
        </div>

       

		<button class="btn btn-primary btn-block ml-auto" @click.prevent="createLents" type="submit">Создать</button>

	
    </b-modal>


</div> 
    </template>
    
    <script>
import VSelectize from '@isneezy/vue-selectize'
import axios from 'axios';
    import { BModal } from 'bootstrap-vue'
    export default {
        components: { BModal, VSelectize },
       name: 'Lenta',
       props: ['kinder_groups', 'platform'],
        data(){
        return {
          selected: {id: '0', title: 'Без категории'},
          options: [],
          kinder_group: {id: '0', name: 'Выберите группу'},
            modalShow: true, 
            socSelect: 'vk',
            laccess: false,
            lentaName: null
        }
       },
       mounted(){
        this.getCats()
       },
       methods: {
        createLents(){
          if(this.lentaName == null || this.lentaName == ''){
            return this.$bvToast.toast('Укажите название ленты', {
          title: 'Ошибка',
          variant: 'danger',
          visible: true
        })
          }
          if(this.platform.type == 'photo'){
            this.socSelect = 'post'
          }
        axios.post('/api/lenta.create', {'soc': this.socSelect, 'category': this.selected.id, 'name': this.lentaName, 'kinder_group': this.kinder_group, 'access': this.laccess}).then( res => {
          this.modalShow = false
          this.$router.push({ name: 'lenta.view', params: { 'id': res.data.id } }) //тут нужно сделать перенаправление если уже в ленте
        }).catch( error => {
             this.$bvToast.toast(error.data.message, {
          title: 'Ошибка',
          variant: 'danger',
          visible: true
        })
        })

        },
        getCats() {
         axios.post('/api/lenta.get.cats').then( res => {
            this.options = res.data
        }).catch( error => {
             this.$bvToast.toast(error.data.message, {
          title: 'Ошибка',
          variant: 'danger',
          visible: true
        })
        })
     },
     swapSoc(tab){
      this.socSelect = tab
     }
       },
       emits: ['remove'],
       computed: {
    checkModal() {
        if(!this.modalShow){
            this.$emit('remove', null)
        }
       
      return 
    }
  }
    }
    </script>
    
    <style scoped>
    
    </style>
    